/* eslint-disable no-param-reassign */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
/* eslint-disable no-alert */
/* eslint-disable import/no-cycle */
import React, { useRef, useState, useEffect } from 'react';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
  Selection, Toolbar, Edit, Sort, Filter,
  ColumnChooser,
  Resize,
} from '@syncfusion/ej2-react-grids';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';

import { notificationsGrid } from '../data/dummy';
import { Header } from '../components';
import './Zackat.css';

const NotificationEvents = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=notificationevents');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const { zRenderMode, isMobile, setNotificationDevice } = useStateContext();

  let grid = useRef(null);
  const details = { text: 'Ack', tooltipText: 'Acknowledge ', prefixIcon: 'e-expand', id: 'ack' };
  const nack = { text: 'NACK', tooltipText: 'Negative Acknowledge ', prefixIcon: 'e-delete-row', id: 'nack' };
  const toolbarOptions = ['Search', details, nack];
  const { REACT_APP_API_ENDPOINT } = process.env;

  const editing = { allowDeleting: false, allowEditing: false };
  const [ack, setAck] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    usr.limit = '10000';
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/notifications?${query}`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          // set state when the data received
          setData(mydata);
          setLoading(false);
        })
        .catch(() => {
        });
    };
    dataFetch();
  }, [ack]);
  // Action handler for the button
  const actionHandler = (args) => {
    if (args.device) {
      localStorage.setItem('currentAssociate', args.name);
      setNotificationDevice(args.name);

      navigate(`/associatelayout?id=${args.associateid}&name=${args.name}`);
    }
  };

  // Template function to render the button
  const buttonTemplate = (props) => (
    <ButtonComponent
      cssClass="e-icons e-user"
      onClick={() => actionHandler(props)}
    >
      {props.name}
    </ButtonComponent>
  );
  const containerStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)', // Creates 2 equal columns
    gap: '16px', // Spacing between the divs
    padding: '16px',
  };

  const boxStyle = {
    backgroundColor: '#F6821E7f',
    color: 'black',
    padding: '24px',
    textAlign: 'center',
    borderRadius: '8px',
    fontSize: '1.25rem',
  };

  if (loading) {
    return <p>Loading... </p>;
  }
  let dialogInstance;
  const clickHandler = (args) => {
    if (grid && args.item.properties.text === 'Ack') {
      const selectedRecords = grid.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        DialogUtility.alert('Please select at least one notification to acknowledge!');
        args.cancel = true;
        return;
      }
      dialogInstance = DialogUtility.confirm({
        title: 'Ack Alerts/Notifications',
        content: `Acknowledge ${selectedRecords.length} Alerts and Notifications?`,
        okButton: { text: 'OK',
          click: () => {
            const notifications = [];
            const user = { user: usr };
            notifications.notifications = selectedRecords;
            const output = { ...user, ...notifications };
            dialogInstance.hide();
            fetch(`${REACT_APP_API_ENDPOINT}/notifications`, {
              method: 'UPDATE',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `JWTToken ${usr.token}`,
              },
              body: JSON.stringify(output),
            })
              .then((response) => response.json())
              .then((responseJson) => {
                // The added/edited data will be saved in the Grid
                if (responseJson && responseJson.response && responseJson.response !== 'OK') {
                  DialogUtility.alert(responseJson.response);
                }
                setAck(!ack);
              })
              .catch(() => {
              });
          },
          cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
          showCloseIcon: true,
          closeOnEscape: true,
          isModal: true,
          animationSettings: { effect: 'Zoom' },
        },
      });
    } else if (grid && args.item.properties.text === 'NACK') {
      const selectedRecords = grid.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        DialogUtility.alert('Please select at least one notification to clear as a non event!');
        args.cancel = true;
        return;
      }

      dialogInstance = DialogUtility.confirm({
        title: 'Negative Acknoledge Alerts/Notifications',
        content: `Clear ${selectedRecords.length} Alerts and Notifications?`,
        okButton: { text: 'OK',
          click: () => {
            const notifications = [];
            const user = { user: usr };
            notifications.notifications = selectedRecords;
            const output = { ...user, ...notifications };
            dialogInstance.hide();

            fetch(`${REACT_APP_API_ENDPOINT}/notifications?nack=true`, {
              method: 'UPDATE',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `JWTToken ${usr.token}`,
              },
              body: JSON.stringify(output),
            })
              .then((response) => response.json())
              .then((responseJson) => {
                // The added/edited data will be saved in the Grid
                if (responseJson && responseJson.response && responseJson.response !== 'OK') {
                  DialogUtility.alert(responseJson.response);
                }
                setAck(!ack);
              })
              .catch(() => {
              });
          },
        },
        cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
        showCloseIcon: true,
        closeOnEscape: true,
        isModal: true,
        animationSettings: { effect: 'Zoom' },
      });
    }
  };
  const FilterOptions = {
    type: 'Menu',
  };
  return (
    <div className={!isMobile ? 'm-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh' : 'bg-white rounded-3xl zackat-divalh w-full mt-44'}>
      <Header category="Operations" title={`Total Active Notification Events ( ${data.notifications.length} )`} />
      <div style={containerStyle}>
        <div style={boxStyle}>{data.results && data.results.totalNotifications && data.results.totalNotifications.toLocaleString('en-US')} 🛎 (safety notifications for {new Date().getFullYear()})</div>
        <div style={boxStyle}>{data.results && data.results.ackNotifications && data.results.totalNotifications && ((data.results.totalHeat / data.results.totalNotifications) * 100).toFixed(0)}% ⚠ (heat related stress events)</div>
        <div style={boxStyle}>{data.results && data.results.ackNotifications && data.results.totalNotifications && ((data.results.ackNotifications / data.results.totalNotifications) * 100).toFixed(0) }% &#x2406; (intervention acknowledgement rate)</div>
        <div style={boxStyle}>{data.results && data.results.totalEvents && data.results.totalEvents.toLocaleString('en-US')} ⌖ (environmental sensor readings collected)</div>
      </div>
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            <GridComponent
              dataSource={data.notifications}
              id="gridnotifications"
              width="auto"
              allowPaging
              allowSorting
              toolbarClick={clickHandler}
              editSettings={editing}
              toolbar={toolbarOptions}
              enableHover={false}
              pageSettings={{ pageSize: 100, pageCount: 10 }}
              allowResizing
              // allowFiltering={data && data.length > 0}
              // filterSettings={FilterOptions}
              // showColumnChooser
              allowTextWrap
              ref={(g) => { grid = g; }}
              enableAdaptiveUI
              rowRenderingMode={zRenderMode}
              enableAltRow
              enableStickyHeader={!isMobile}
              enablePersistence={false}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="_id"
                  headerText="ID"
                  width="100"
                  isPrimaryKey
                  visible={false}
                />
                <ColumnDirective
                  type="checkbox"
                  width="50"
                />
                <ColumnDirective
                  field="device"
                  headerText="Name"
                  width="150"
                  textAlign="Left"
                  visible
                  template={buttonTemplate}
                />
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                {notificationsGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
              </ColumnsDirective>
              <Inject services={[Search, Page, Selection, Toolbar, Edit, Sort, Filter, ColumnChooser, Resize]} />
            </GridComponent>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NotificationEvents;
